import React from "react";

import { Box } from "@material-ui/core";
import { get } from "lodash";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    boxShadow: "inset 0px -1px 0px #EEEEEE",
    padding: "1rem",
    minHeight: "72px",
  },
}));

const NoFutureLessons = () => {
  const classes = useStyles();

  return (
    <Box flexGrow={1} className={clsx(get(classes, "container"), "break")}>
      No lessons booked for today
    </Box>
  );
};

export default NoFutureLessons;
